import { ButtonBase, Typography, useTheme } from "@mui/material";
import type { FC } from "react";

type Props = {
	label: string;
	selected: boolean;
	disabled: boolean;
	outside?: boolean;
	onClick: () => void;
};

export const FlatRowDatePanelCell: FC<Props> = ({
	label,
	selected,
	disabled,
	outside,
	onClick,
}) => {
	const { palette, radii, datePanel } = useTheme();

	return (
		<ButtonBase
			disabled={disabled}
			onClick={onClick}
			aria-pressed={selected}
			sx={[
				{
					height: datePanel.cellHeight,
					borderRadius: radii.md,
					color: palette.grey[900],
				},
				outside === true && { color: palette.grey[400] },
				disabled && { color: palette.grey[300] },
				selected && {
					bgcolor: palette.blue[600],
					color: palette.darkmodeText.white,
				},
			]}
		>
			<Typography
				component="span"
				variant={selected ? "bodyStrong" : "body2"}
				color="inherit"
				tabular
			>
				{label}
			</Typography>
		</ButtonBase>
	);
};
